<template>
  <PullRefresh
    v-model="isLoading"
    success-text="刷新成功"
    @refresh="onRefresh"
    :disabled="dialogVisible"
  >
    <div :class="`${$style.pageContent}`">
      <div :class="$style.bannerBox">
        <img :src="activityInfo.background" />
      </div>
      <div :class="$style.gameInfo">
        <div>
          <img :src="activityInfo.gameActiveCommonVo.logo" />
          <div>
            <p :class="$style.title">
              {{ activityInfo.gameActiveCommonVo.appName }}
            </p>
            <p
              :class="$style.type"
              v-if="activityInfo.gameActiveCommonVo.categoryNames.length > 0"
            >
              {{ activityInfo.gameActiveCommonVo.categoryNames.join("·") }}
            </p>
            <p :class="$style.tag">
              <span
                v-for="item in activityInfo.gameActiveCommonVo.tags"
                :key="item.id"
                >{{ item.labelName }}</span
              >
            </p>
          </div>
          <div
            :class="$style.button"
            @click="onSkipDetail(activityInfo.gameActiveCommonVo.gameId)"
          >
            下载/查看
          </div>
        </div>
      </div>
      <div :class="$style.notice">
        <div :class="$style.time">
          <CountDown :time="countdownTime" @finish="onRefresh">
            <template #default="timeData">
              <span>礼包刷新倒计时:{{ timeData.days }}天</span>
              <span>{{ timeData.hours }}时</span>
              <span>{{ timeData.minutes }}分</span>
              <span>{{ timeData.seconds }}秒</span>
            </template>
          </CountDown>
        </div>
        <div :class="$style.switch">
          <p :class="$style.switchDesc">{{ tipSwitch ? "已" : "" }}开启提醒</p>
          <van-switch
            :value="tipSwitch"
            size="17px"
            active-color="#ff9916"
            @change="onClickSwitch"
          />
        </div>
      </div>
      <div :class="$style.activityGifts" @touchmove.stop @touchend.stop>
        <div>
          <div :class="$style.giftWrapper">
            <img
              :class="$style.line"
              :src="`${CDN_URL_1}/box_weekGift/${
                dayLine[activityInfo.weekToGiftVoList.length]
              }.png`"
              alt=""
            />
            <div :class="$style.giftList">
              <div
                v-for="item in activityInfo.weekToGiftVoList"
                :key="item.weekToGiftId"
                :class="$style.giftItem"
              >
                <img :class="$style.icon" :src="item.giftIcon" />
                <div :class="$style.info">
                  <h3 :class="$style.type">
                    {{ dayDesc[item.dayOfWeek] }}礼包
                  </h3>
                  <h3 :class="$style.title">{{ item.giftName }}</h3>
                  <p :class="$style.content">
                    {{ item.giftDesc }}
                  </p>
                </div>
                <div
                  :class="`${$style.giftBtn} ${
                    !item.drawStatus &&
                    activityInfo.dayOfWeek == item.dayOfWeek &&
                    activityInfo.buttonStatus > 1
                      ? ''
                      : $style.disableBtn
                  }`"
                  @click="onReceiveGift(item)"
                >
                  {{ drawStatusText(item) }}
                </div>
              </div>
            </div>
          </div>
          <div :class="$style.footer" :style="{filter: [0, 1, 4].includes(activityInfo.buttonStatus) ? 'none':'grayscale(1)'}" @click="onClickSign">
            {{ buttonText }}
          </div>
        </div>
      </div>
      <!-- 弹窗 -->
      <ActivityDialog
        :title="dialogTitle"
        :visible="dialogVisible"
        :hideCancel="dialogType == 1"
        :sureText="sureText"
        @click-sure="onSureDialog"
        @click-cancel="dialogVisible = false"
        :herderStyle="{ background: '#FFB503' }"
        :sureStyle="{ background: '#FD3665' }"
        :cancelStyle="{
          background: '#fff2f2',
          color: '#fc5f5e',
          filter: 'none',
        }"
      >
        <template v-slot:main>
          <!-- 激活成功 -->
          <div v-if="dialogType == 1">
            <p>
              请点击{{
                dayDesc[activityInfo.dayOfWeek]
              }}礼包的<span>【领取】</span>按钮
            </p>
            <p>领取您的奖励</p>
          </div>
          <!-- 不满足活动条件 -->
          <div v-if="dialogType == 2">
            <p>
              当前账号在<span
                >[{{ activityInfo.gameActiveCommonVo.appName }}]</span
              >中
            </p>
            <p>没有游戏记录，进入游戏</p>
            <p>后可参与活动。</p>
          </div>
          <!-- 领取成功 -->
          <div v-if="dialogType == 3">
            <p :style="{ textAlign: 'center', marginBottom: '10px' }">
              礼包码已存放在
            </p>
            <p :style="{ textAlign: 'center', width: '100%' }">
              【我的】-【我的礼包】-【活动礼包】
            </p>
          </div>
          <!-- 礼包码生成错误 -->
          <div v-if="dialogType == 4">
            <p>兑换码生成错误</p>
            <p>请联系客服领取备用码</p>
          </div>
          <div v-if="dialogType === 5">
            <p>当前账号不满足条件，请进入</p>
            <p>游戏且等级达{{ activityInfo.roleLimit }}级后参与活动</p>
          </div>
        </template>
      </ActivityDialog>
    </div>
  </PullRefresh>
</template>

<script>
import { inithandler } from "@/bridge/jsBridge";
import { CDN_URL_1, CDN_URL } from "@/config";
import {
  setPageTitle,
  getUserInfo,
  toLogin,
  signInEventTrack,
  jumpToNative,
  setRightTxt,
  clickRightTxt,
  setRightTxtColor,
  openNotification,
  isOpenNotification,
  dataLoadFinished,
} from "@/bridge/AppJsBridge";
import { PullRefresh, CountDown } from "vant";
import ActivityDialog from "@/components/btBox/ActivityDialog";
import { getCookie, pageLoseTips } from "@/libs/utils";
import {
  weekGiftListApi,
  weekGiftClickApi,
  getWeekGiftApi,
} from "@/apis/wxActivity";
import { burnPoint } from "@/apis/heziShare";
import { queue } from "../../../libs/queue.request";
import moment from "moment";

export default {
  name: "",
  components: {
    PullRefresh,
    ActivityDialog,
    CountDown,
  },
  data() {
    return {
      CDN_URL_1: CDN_URL_1,
      CDN_URL: CDN_URL,
      pageTitle: "",
      activityId: "",
      activityGameId: "",
      isLoading: false,
      reqQueue: queue(),
      dialogType: 1, // 1-激活成功 2-不满足领取条件 3-领取成功 4-礼包码生成错误
      cookie: null,
      tipSwitch: false,
      activityInfo: {
        buttonStatus: 0,
        nowTime: "",
        nextTime: "",
        dayOfWeek: 0,
        gameActiveCommonVo: {
          logo: "",
          appName: "",
          categoryNames: [],
          tags: [],
        },
        weekToGiftVoList: [],
        background: "",
        roleLimit: "",
      },
      dialogVisible: false,
      dialogTitle: "激活成功",
      sureText: "",
      curGiftInfo: {
        giftId: 0,
        weekToGiftId: 0,
        drawStatus: 0,
      },
      dayDesc: ["无", "周一", "周二", "周三", "周四", "周五", "周六", "周日"],
      dayLine: ["无", "one", "two", "three", "four"],
      pageType: 0,
    };
  },
  computed: {
    countdownTime: function () {
      let time = 7 * 24 * 60 * 60 * 1000;
      if (this.activityInfo.nowTime && this.activityInfo.nextTime) {
        time =
          moment(this.activityInfo.nextTime).valueOf() -
          moment(this.activityInfo.nowTime).valueOf();
      }
      return time;
    },
    buttonText: function () {
      let text = "";
      let status = this.activityInfo.buttonStatus;
      let dayOfWeek = this.activityInfo.dayOfWeek;
      let curGiftDay = 0;
      if (status == 0) {
        text = "下载游戏后可参与";
      }
      if (status == 1) {
        text = `点我激活${this.dayDesc[dayOfWeek]}礼包`;
      }
      if (status == 2) {
        text = `${this.dayDesc[dayOfWeek]}礼包已激活`;
      }
      if (status == 3) {
        let day = 7;
        for (const gift of this.activityInfo.weekToGiftVoList) {
          if (gift.dayOfWeek > dayOfWeek && gift.dayOfWeek - dayOfWeek < day) {
            day = gift.dayOfWeek - dayOfWeek;
            curGiftDay = gift.dayOfWeek;
          }
          if (gift.dayOfWeek < dayOfWeek && 7 - dayOfWeek + gift.dayOfWeek < day) {
            day = 7 - dayOfWeek + gift.dayOfWeek;
            curGiftDay = gift.dayOfWeek;
          }
        }

        text = `${day}天后可激活${this.dayDesc[curGiftDay]}礼包`;
      }
      if (status === 4) {
        text = "下载游戏后可参与"
      }
      return text;
    },
    drawStatusText: function () {
      return function ({ drawStatus, dayOfWeek }) {
        let text = "领取";
        let day = this.activityInfo.dayOfWeek;
        if (drawStatus == 1) {
          return (text = "已领取");
        }
        if (day !== dayOfWeek || this.activityInfo.buttonStatus == 0) {
          text = `${this.dayDesc[dayOfWeek]}可激活`;
        }
        if (day == dayOfWeek && this.activityInfo.buttonStatus == 1) {
          text = `${this.dayDesc[dayOfWeek]}可激活`;
        }
        return text;
      };
    },
  },
  created() {
    const { history } = this.$router;
    const { isFirstEnter } = history.current.query;
    if (isFirstEnter) {
      try {
        inithandler();
      } catch (error) {
        console.log("error:", error)
      }
    }
    // 页面初始化
    this.reqQueue.create();
    this.initPageData();
    try {
      signInEventTrack((data) => {
        this.cookie = JSON.parse(data);
      });
    } catch (error) {
      // 错误处理
    }
  },
  activated() {
    setRightTxt("活动规则");
  },
  watch: {
    cookie(value, oldValue) {
      if (!oldValue && value && !getCookie()) {
        this.reqQueue.run(value);
      }
    },
  },
  methods: {
    // 下拉刷新
    async onRefresh() {
      await this.initPageData();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    // 设置顶部内容
    setHeaderContent() {
      setRightTxtColor("#6879AD");
      setRightTxt("活动规则");
      clickRightTxt(() => {
        this.$router.push({
          name: `box.actPlaceRule`,
          params: {
            type: 18,
          },
        });
        this.eventTrack({
          event: "weekly_act_place_rule",
          event_field: JSON.stringify({
            act_name: this.pageTitle,
            type: this.pageType,
          }),
          appName: this.activityInfo.gameActiveCommonVo.appName,
          appkey: this.activityInfo.gameActiveCommonVo.gameId,
        });
      });
    },

    // 数据上报
    eventTrack(data) {
      // this.$toast(data.event);
      if (!this.cookie) {
        console.log("数据上报异常", data.event, "转为补充数据上报");
        this.reqQueue.add(burnPoint, data);
        return;
      }
      console.log("正常数据上报", data.event);
      burnPoint({
        ...this.cookie,
        ...data,
      }).catch((err) => console.log(err));
    },

    // 获取缓存等携带的用户信息数据
    async initPageData() {
      const { history } = this.$router;
      const { activityId, activityGameId, title, type } = history.current.query;
      if (!activityId || isNaN(activityId)) {
        pageLoseTips(this.$toast);
        return;
      }
      this.activityId = activityId;
      this.activityGameId = activityGameId;
      this.pageTitle = title;
      this.pageType = type;
      setPageTitle(title);
      this.setHeaderContent();
      const pageCookie = getCookie();
      if (pageCookie) {
        for (const key in pageCookie) {
          if (
            Object.hasOwnProperty.call(pageCookie, key) &&
            pageCookie[key] === "null"
          ) {
            delete pageCookie[key];
          }
        }
        this.cookie = pageCookie;
      }
      // 获取token
      this.getAppToken();
    },

    // 获取登录态
    getAppToken() {
      if (getCookie("token")) {
        localStorage.setItem("token", getCookie("token"));
        this.getActivityMainConfig();
      } else {
        getUserInfo((userInfo) => {
          let Info = JSON.parse(userInfo);
          if (Info.token) {
            localStorage.setItem("token", Info.token);
          }
          this.getActivityMainConfig();
        });
      }
    },

    // 获取活动主配置
    getActivityMainConfig() {
      weekGiftListApi({
        activityId: this.activityId,
        activityGameId: this.activityGameId,
      })
        .then((res) => {
          const { data } = res;
          this.activityInfo = data;
          dataLoadFinished();
          this.getTipSwitchStatus();
        })
        .catch((err) => {
          const { response } = err;
          if (response) {
            const { data } = response;
            if (data && data.code === 401) {
              toLogin("/loginKey/LoginByKeyPhoneActivity");
            }
          }
        });
    },

    // 点击激活
    onClickSign() {
      const { buttonStatus, gameActiveCommonVo } = this.activityInfo
      if (!buttonStatus || buttonStatus === 4) {
        this.eventTrack({
          event: "weekly_act_place_sign_enter_game",
          event_field: JSON.stringify({
            act_name: this.pageTitle,
            type: this.pageType,
          }),
          appName: gameActiveCommonVo.appName,
          appkey: gameActiveCommonVo.gameId,
        });
        this.openDialog(buttonStatus === 4 ? 5 : 2);
        return;
      }
      if (buttonStatus != 1) {
        return;
      }
      this.eventTrack({
        event: "weekly_act_place_sign_enable",
        event_field: JSON.stringify({
          act_name: this.pageTitle,
          type: this.pageType,
        }),
        appName: gameActiveCommonVo.appName,
        appkey: gameActiveCommonVo.gameId,
      });
      weekGiftClickApi({
        activityId: this.activityId,
        activityGameId: this.activityGameId,
      }).then((res) => {
        this.openDialog(1);
        this.getActivityMainConfig();
      });
    },

    // 通知状态
    onClickSwitch() {
      openNotification();
      this.eventTrack({
        event: "weekly_act_place_app_notice",
        event_field: JSON.stringify({
          act_name: this.pageTitle,
          type: this.pageType,
          app_notice: Number(this.tipSwitch),
        }),
        appName: this.activityInfo.gameActiveCommonVo.appName,
        appkey: this.activityInfo.gameActiveCommonVo.gameId,
      });
    },

    // 领取礼包操作
    onReceiveGift(data) {
      const { drawStatus, giftId, giftName, dayOfWeek } = data;
      const { buttonStatus } = this.activityInfo;
      this.curGiftInfo = data;
      if (drawStatus) {
        // 已领取
        this.openDialog(3);
        return;
      }
      if (buttonStatus != 2 || dayOfWeek !== this.activityInfo.dayOfWeek) {
        // 当前不可领取
        return;
      }
      const eventField = JSON.stringify({
        act_name: this.pageTitle,
        type: this.pageType,
        gift_id: giftId,
        gift_name: giftName,
        week_name: this.dayDesc[dayOfWeek],
      });
      this.eventTrack({
        event: "weekly_act_place_get_gift",
        event_field: eventField,
        appName: this.activityInfo.gameActiveCommonVo.appName,
        appkey: this.activityInfo.gameActiveCommonVo.gameId,
      });
      getWeekGiftApi({ weekToGiftId: data.weekToGiftId })
        .then((res) => {
          const { data, code } = res;
          this.amount = data.rechargeMoney;
          this.getActivityMainConfig();
          if (data.cdk) {
            this.eventTrack({
              event: "weekly_act_place_get_gift_success_pop",
              event_field: eventField,
              appName: this.activityInfo.gameActiveCommonVo.appName,
              appkey: this.activityInfo.gameActiveCommonVo.gameId,
            });
            this.openDialog(3);
          } else {
            this.openDialog(4);
          }
        })
        .catch((error) => {});
    },

    // 打开弹窗
    openDialog(type) {
      this.dialogVisible = true;
      this.dialogType = type * 1;
      if (type == 1) {
        this.dialogTitle = "激活成功";
        this.sureText = "我知道了";
        this.eventTrack({
          event: "weekly_act_place_sign_enable_pop",
          event_field: JSON.stringify({
            type: this.pageType,
            act_name: this.pageTitle,
          }),
          appName: this.activityInfo.gameActiveCommonVo.appName,
          appkey: this.activityInfo.gameActiveCommonVo.gameId,
        });
      }
      if ([2, 5].includes(type * 1)) {
        if (type === 2) {
          this.dialogTitle = "下载游戏后可参与";
          this.sureText = "下载/查看游戏";
        }
        if (type === 5) {
          this.dialogTitle = "不满足活动条件";
          this.sureText = "下载/查看游戏";
        }
        this.eventTrack({
          event: "weekly_act_place_sign_enter_game_pop",
          event_field: JSON.stringify({
            type: this.pageType,
            act_name: this.pageTitle,
          }),
          appName: this.activityInfo.gameActiveCommonVo.appName,
          appkey: this.activityInfo.gameActiveCommonVo.gameId,
        });
      }
      if (type == 3) {
        this.dialogTitle = "领取成功";
        this.sureText = "查看兑换码";
      }
      if (type == 4) {
        this.dialogTitle = "提示";
        this.sureText = "联系客服";
      }
    },

    // 确认弹窗
    onSureDialog() {
      if ([2, 5].includes(this.dialogType)) {
        this.onSkipDetail(this.activityInfo.gameActiveCommonVo.gameId, true);
        this.eventTrack({
          event: "weekly_act_place_sign_pop_look_game",
          event_field: JSON.stringify({
            type: this.pageType,
            act_name: this.pageTitle,
          }),
          appName: this.activityInfo.gameActiveCommonVo.appName,
          appkey: this.activityInfo.gameActiveCommonVo.gameId,
        });
      }
      if (this.dialogType == 3) {
        this.onGoGiftDetail();
      }
      if (this.dialogType == 4) {
        this.onRelationServer();
      }
      this.dialogVisible = false;
    },

    // 游戏详情
    onSkipDetail(gameId, isPop = false) {
      if (!isPop) {
        this.eventTrack({
          event: "weekly_act_place_look_game",
          event_field: JSON.stringify({
            act_name: this.pageTitle,
            type: this.pageType,
          }),
          appName: this.activityInfo.gameActiveCommonVo.appName,
          appkey: this.activityInfo.gameActiveCommonVo.gameId,
        });
      }
      const data = {
        routePath: "/main/game/GameDetailActivity",
        extraParams: gameId,
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    // 礼包详情
    onGoGiftDetail() {
      this.eventTrack({
        event: "weekly_act_place_look_gift_success",
        event_field: JSON.stringify({
          act_name: this.pageTitle,
          type: this.pageType,
          gift_id: this.curGiftInfo.giftId,
          gift_name: this.curGiftInfo.giftName,
          week_name: this.dayDesc[this.curGiftInfo.dayOfWeek],
        }),
        appName: this.activityInfo.gameActiveCommonVo.appName,
        appkey: this.activityInfo.gameActiveCommonVo.gameId,
      });
      const data = {
        routePath: "/gift/MineGiftActivity",
        extraParams: 3,
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    // 联系客服
    onRelationServer() {
      this.dialogVisible = false;
      this.$router.push({
        name: `box.customerService`,
      });
    },

    /**
     * 获取当前页面通知权限开关状态
     */
    getTipSwitchStatus() {
      isOpenNotification((status) => {
        // 首次进入此方法无效，后续修改开关返回当前页面获取状态更新
        this.tipSwitch = status == "1" ? true : false;
        this.eventTrack({
          event: "weekly_act_place_page",
          event_field: JSON.stringify({
            type: this.pageType,
            act_name: this.pageTitle,
            app_notice: Number(status),
          }),
          appName: this.activityInfo.gameActiveCommonVo.appName,
          appkey: this.activityInfo.gameActiveCommonVo.gameId,
        });
      });
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="scss" module>
.pageContent {
  width: 100%;
  min-height: 100vh;
  max-width: 375px;
  margin: auto;
  overflow: auto;
  background-size: cover;
  background: #f8f8f8;
  position: relative;
  padding: 0 14px;

  .bannerBox {
    background-color: #fdd37b;
    width: 100%;
    border: 4px solid #fdd37b;
    border-radius: 1px;
    overflow-y: auto;
    // min-height: 80px;
    margin-top: 6px;
    > img {
      width: 100%;
    }
  }

  .gameInfo {
    background-color: #fdd37b;
    width: 100%;
    border: 4px solid #fdd37b;
    border-radius: 1px;
    overflow-y: auto;
    margin-top: 12px;
    > div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: rgba(246, 246, 246, 0.85);
      height: 100px;
      padding: 0 6px;
      > img {
        width: 69px;
        height: 69px;
      }
      .title {
        width: 160px;
        height: 18x;
        line-height: 18px;
        font-size: 18px;
        font-weight: 700;
        text-align: left;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        white-space: nowrap;
        margin-bottom: 6px;
      }
      .type {
        width: 160px;
        height: 13px;
        line-height: 13px;
        font-size: 13px;
        font-weight: 400;
        text-align: left;
        color: #999999;
        margin-bottom: 4px;
      }
      .tag {
        > span {
          height: 17px;
          line-height: 17px;
          background: #ff6d6d;
          border-radius: 2px;
          font-size: 12px;
          font-weight: 400;
          text-align: center;
          color: #ffffff;
          padding: 1px 3px;
          margin-right: 3px;
        }
      }
      .button {
        width: 85px;
        height: 30px;
        line-height: 30px;
        background: linear-gradient(
          44deg,
          rgba(255, 142, 27, 0.87) 0%,
          rgba(254, 184, 26, 0.87) 90%
        );
        border-radius: 15px;
        font-size: 15px;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
      }
    }
  }

  .notice {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 36px;
    .time {
      span {
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        color: #fd3665;
        line-height: 12.85px;
      }
    }
    .switch {
      display: flex;
      align-items: center;
      .switchDesc {
        color: #333333;
        font-size: 13px;
        margin-right: 4px;
      }
    }
  }

  .activityGifts {
    background-color: #fdd37b;
    width: 100%;
    border: 4px solid #fdd37b;
    border-radius: 1px;
    overflow-y: auto;
    > div {
      background: rgba(246, 246, 246, 0.85);
      padding: 0 6px;
      height: 440px;
      .giftWrapper {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .line {
          width: 29px;
        }
        .giftList {
          width: 90%;
          display: flex;
          flex-direction: column;
          height: 380px;
          justify-content: space-evenly;
          .giftItem {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .icon {
              width: 64px;
              height: 64px;
              border: 3px solid #ffb369;
              background-color: #f6f6f6;
            }
            .info {
              width: 138px;
              .type {
                width: 80px;
                height: 16px;
                font-size: 17px;
                font-weight: 700;
                text-align: left;
                color: #833d13;
                line-height: 16px;
                margin-bottom: 2px;
              }
              .title {
                width: 100%;
                height: 13px;
                line-height: 13px;
                font-size: 13px;
                font-weight: 500;
                text-align: left;
                color: #dc4026;
                margin-bottom: 2px;
              }
              .content {
                width: 100%;
                height: 26px;
                line-height: 13px;
                font-size: 12px;
                font-weight: 400;
                text-align: left;
                color: #b16635;
              }
            }
            .giftBtn {
              width: 75px;
              height: 28px;
              line-height: 28px;
              background: #ff9916;
              border-radius: 12px;
              font-size: 12px;
              font-weight: 500;
              text-align: center;
              color: #ffffff;
            }
            .disableBtn {
              filter: grayscale(1);
            }
          }
        }
      }
      .footer {
        width: 84%;
        height: 40px;
        line-height: 40px;
        background: #fd3665;
        border-radius: 21px;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        margin: 8px auto 0;
      }
    }
  }
}
</style>
